import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function removeUndefined(obj) {
  for (var k in obj) {
    if (obj[k] === undefined || obj[k] === null) delete obj[k];
  }

  return obj;
}

function isObject(obj) {
  if (obj === null || typeof obj !== 'object') return false;
  return Object.prototype.toString.call(obj) === '[object Object]';
}

var API_CACHE_KEY = 'apiCacheStore';

var CacheStore = /*#__PURE__*/function () {
  function CacheStore(useLocalStorage) {
    _classCallCheck(this, CacheStore);

    _defineProperty(this, "data", {});

    _defineProperty(this, "useLocalStorage", void 0);

    this.useLocalStorage = useLocalStorage;

    if (useLocalStorage) {
      var localstorageCache = localStorage.getItem(API_CACHE_KEY);
      if (localstorageCache) this.data = JSON.parse(localstorageCache);
    }
  }

  _createClass(CacheStore, [{
    key: "add",
    value: function add(url, value) {
      this.data[url] = value;

      if (this.useLocalStorage) {
        localStorage.setItem(API_CACHE_KEY, JSON.stringify(this.data));
      }
    }
  }, {
    key: "get",
    value: function get(url) {
      return this.data[url];
    }
  }]);

  return CacheStore;
}();

export var apiCacheStore = new CacheStore(false);

var ApiCache = /*#__PURE__*/function () {
  function ApiCache() {
    _classCallCheck(this, ApiCache);

    _defineProperty(this, "cacheStore", void 0);

    this.cacheStore = apiCacheStore; // using false cause data can become more than 5 mbs - localStorage max size is 5mb
  }

  _createClass(ApiCache, [{
    key: "assignAdapter",
    value: function assignAdapter(response, config) {
      function adapter(config) {
        return new Promise(function (resolve) {
          return resolve(response);
        });
      }

      config.adapter = adapter;
    }
  }, {
    key: "handleRequest",
    value: function handleRequest(config) {
      if (config.headers && config.headers.get('useCache') && config.url && config.baseURL) {
        var url = "".concat(new URL(config.url, config.baseURL).toString(), "?").concat(new URLSearchParams(removeUndefined(config.params)));
        var cachedData = this.cacheStore.get(url);

        if (cachedData) {
          this.assignAdapter(cachedData, config);
        }
      }

      if (config && config.headers && config.headers.get('useCache') !== undefined) {
        config.headers["delete"]('useCache');
      }
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(response) {
      var config = response.config;
      var url = config ? "".concat(new URL(config.url || '', config.baseURL).toString(), "?").concat(new URLSearchParams(removeUndefined(config.params))) : "";
      if (isObject(response.data)) response.data.cacheUrl = url;
      this.cacheStore.add(url, response);
      return response;
    }
  }]);

  return ApiCache;
}();

export { ApiCache as default };